import { Flex, Image, ConnectionItem, AddNewButton } from "@wayflyer/flyui";
import { useState, type ReactNode } from "react";
import { useIntl } from "react-intl";
import type { ConnectorPropertiesSchema } from "shared-ui";

import { COMMON_MESSAGES } from "../../common-messages";

export const ConnectionsList = ({
  connectorProperties,
  connectForm,
}: {
  connectorProperties: ConnectorPropertiesSchema;
  connectForm: ReactNode;
}) => {
  const intl = useIntl();
  const [isFormVisible, setFormVisible] = useState(false);

  const connectedPlatformsList: string[] | null =
    connectorProperties && !!connectorProperties.connections.length
      ? connectorProperties.connections.map((connection) => {
          return connection.identifierName ?? connectorProperties.name;
        })
      : null;

  return (
    <Flex direction="column" width="100%" gap="2">
      {connectedPlatformsList ? (
        <>
          <ConnectionItem
            label={connectorProperties.name}
            logo={
              connectorProperties.connectionLogoSrc ? (
                <Image src={connectorProperties.connectionLogoSrc} alt="" />
              ) : undefined
            }
            badgeStatus="positive"
            badgeText={intl.formatMessage(COMMON_MESSAGES.connected)}
            subtitle={
              <ul>
                {connectedPlatformsList?.map((value, index) => (
                  <li key={value + index}>{value}</li>
                ))}
              </ul>
            }
          />

          {!isFormVisible && connectorProperties.multipleConnectionsAllowed && (
            <Flex height="var(--sizes-spacing-16)">
              <AddNewButton orientation="row-centered" onClick={() => setFormVisible(true)}>
                {intl.formatMessage(COMMON_MESSAGES.addAnother)}
              </AddNewButton>
            </Flex>
          )}

          {isFormVisible && (
            <Flex direction="column" padding={["4", "0"]} gap="2">
              {connectForm}
            </Flex>
          )}
        </>
      ) : (
        connectForm
      )}
    </Flex>
  );
};
